export const PXPosterVideo = (function() {
	'use strict';

	function init() {
		
		var $media_toggle = $('.video .media-toggle');
		var $video = $('.video .media-video iframe');
		

		$media_toggle.on('click', function(event) {
			event.preventDefault();
			$(this).addClass('video--active');
			$video[0].setAttribute('src', $video[0].getAttribute('src') + '&autoplay=1');
			
		});

		

	}

	function events() {}

	return {
		init: init
	};
})();
